import React, { useState, useEffect } from "react";
import { Button, Menu, Dropdown, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axiosWithAuth from "../../utils/axiosWithAuth";
import "../../../src/assets/css/floatingButton.css";
import { DASHBOARD_URL } from "../../common/constants";
import formatBusinessName from "../../utils/formatBusinessName";

export default function FloatingButton() {
  const [businesses, setBusinesses] = useState([]);

  useEffect(() => {
    getAllBusiness();
  }, []);

  const getAllBusiness = async () => {
    try {
      const response = await axiosWithAuth().get(`/api/business/owner`);
      // Filter only activated businesses for security
      const activatedBusinesses = response.data.filter(
        (business) => business.activated === 1
      );
      setBusinesses(activatedBusinesses);
    } catch (error) {
      console.error("Error getting businesses", error);
    }
  };

  // Generate localstorage to know which business you are managing
  const manageBusiness = (id) => {
    // Security check: ensure the business is activated before allowing access
    const business = businesses.find((b) => b.id.toString() === id.toString());

    if (!business || business.activated !== 1) {
      console.warn("Access denied: Business not activated or not found");
      return;
    }

    localStorage.setItem("editBusiness", id);
    window.location.replace(`${DASHBOARD_URL}/business`);
  };

  const menu = (
    <Menu>
      {businesses &&
        businesses.map((business) => (
          <Menu.Item
            key={business.url}
            onClick={() => manageBusiness(`${business.id}`)}
          >
            {formatBusinessName(business.name)}
          </Menu.Item>
        ))}
    </Menu>
  );

  return (
    <>
      {businesses && businesses.length > 0 && (
        <div className="floating-button">
          <Tooltip title="My Businesses" placement="left">
            <Dropdown overlay={menu} trigger={["click"]} placement="topLeft">
              <Button type="primary" size="large">
                <FontAwesomeIcon icon="fa-solid fa-briefcase" />
              </Button>
            </Dropdown>
          </Tooltip>

          {/* <Button
            className="toggle-button"
            shape="circle"
            onClick={() => setVisible(!visible)}
          >
            {visible ? "-" : "+"}
          </Button> */}
        </div>
      )}
    </>
  );
}
